import { useFormikContext } from 'formik';
import clsx from 'clsx';
import { Dropdown, ErrorContainer, LabelComponent, Stack, Tooltip } from 'components';
import { typesOfSupportData } from 'store/clients/clientsSlice';

import style from './typeOfSupport.module.scss';
import { ZCodesField } from './zCodesField';

interface TypeOfSupportProps {
  disabled: boolean;
}

export const TypeOfSupport = ({ disabled }: TypeOfSupportProps) => {
  const formik = useFormikContext<{ typeOfSupport: string[] }>();

  return (
    <>
      <Stack>
        <Stack display="flex" flexDirection="row" alignItems="center" gap="4px">
          <LabelComponent mandatory text="What type of support did you provide?" />
          <Tooltip
            placement="right"
            toolTipText={
              <Stack
                width="333px"
                display="flex"
                gap="8px"
                padding="4px"
                className={style.typeOfSupportInfo}
              >
                <p>Here's what the different kinds of support mean:</p>
                <ul>
                  <li>
                    <span>Social support</span> is being there for someone, e.g. going for a walk or
                    making a care package
                  </li>
                  <li>
                    <span>Coaching for health habits</span> is working to help someone achieve their
                    well-being goals, e.g. working out with them at the YMCA
                  </li>
                  <li>
                    <span>Navigation for healthcare and Navigation for mental healthcare</span> are
                    helping someone get what they need from the healthcare system, e.g. going with
                    them to an appointment
                  </li>
                  <li>
                    <span>Advocacy for empowerment</span> is speaking up with and on behalf of
                    someone, e.g. organizing a community action group
                  </li>
                  <li>
                    <span>Problem solving</span> is taking action to address specific challenges.
                    Remember to take action, don't just hand out a referral!
                  </li>
                </ul>
              </Stack>
            }
          >
            <span className={clsx('material-icons', style.infoIcon)}>info</span>
          </Tooltip>
        </Stack>
        <Dropdown
          smallDropdown
          withGradient
          label="Select"
          data={typesOfSupportData}
          onChange={(e) => {
            formik.handleChange(e);
            if (
              (e.target.value.length === 1 && e.target.value[0] === 'NONE') ||
              e.target.value.length === 0
            ) {
              formik.setFieldValue('selectedZCodes', []);
              return;
            }
          }}
          onBlur={formik.handleBlur}
          name="typeOfSupport"
          id="typeOfSupport"
          value={formik.values.typeOfSupport}
          categoryList={[{ id: 'PROBLEM_SOLVING', label: 'Problem solving' }]}
          categorySelectable
          multiSelect
          disabled={disabled}
        />
        <ErrorContainer
          name="typeOfSupport"
          errors={formik.errors}
          visible={formik.touched.typeOfSupport && Boolean(formik.errors.typeOfSupport)}
        />
      </Stack>
      {formik.values.typeOfSupport.some((type) => type !== 'NONE') && (
        <ZCodesField disabled={disabled} />
      )}
    </>
  );
};
